export default __webpack_public_path__ + "static/media/Perfect_Manhattan-4774-1.d3f463d2.jpeg";